import { render } from "./MerchantOrderDetail.vue?vue&type=template&id=d6163d9a&scoped=true"
import script from "./MerchantOrderDetail.vue?vue&type=script&lang=js"
export * from "./MerchantOrderDetail.vue?vue&type=script&lang=js"

import "./MerchantOrderDetail.vue?vue&type=style&index=0&id=d6163d9a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6163d9a"]])

export default __exports__